var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 123,
    viewBox: "0 0 25 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_814_9495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -10,
    width: 25,
    height: 137
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -10,
    width: 25,
    height: 137,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_814_9495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.66699C0 2.90557 -2.23858 0.666992 -5 0.666992C-7.76142 0.666992 -10 2.90556 -10 5.66699V35.2023C-10 43.2311 -15 50.9715 -15 59.0003C-15 67.0291 -10 74.7695 -10 82.7983V117.334C-10 120.095 -7.76142 122.334 -5 122.334C-2.23858 122.334 0 120.095 0 117.334V97.5632C0 84.5498 15 72.0137 15 59.0003C15 58.3593 14.9598 57.7278 14.8818 57.108C13.3873 45.2355 0 34.2998 0 22.3337V5.66699Z",
    fill: "#EED382"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLink);
export default __webpack_public_path__ + "static/media/active-link.b246de85344536e553ea0cffb55c4d71.svg";
export { ForwardRef as ReactComponent };